// extracted by mini-css-extract-plugin
export default {"multiEmails":"styles_multiEmails__+OBvV","inputDisabled":"styles_inputDisabled__yG05o","inputAllowed":"styles_inputAllowed__6EehA"};